export default "__VITE_ASSET__SKZYnJbu__";